const options = {
    root: null, // relative to the viewport
    rootMargin: '0px',
    threshold: 0 // it triggers as soon as the element enters the viewport
  };
  
  let startScrollPosition = 0;
  
  // Callback function
  const callback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // When the .positioning-scroll comes into view, save the start scroll position
        startScrollPosition = window.scrollY;
      }
    });
  };
  
  // Create Intersection Observer
  const observer = new IntersectionObserver(callback, options);
  
  // Start observing .positioning-scroll
  const target = document.querySelector('.positioning-scroll');
  if (target) {
    observer.observe(target);
  }
  
  // Listen for scroll event
  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
  
    // Calculate the percentage of the viewport the user has scrolled through
    let scrollPercentage = (currentScrollY - startScrollPosition) / window.innerHeight;
  
    // Check if the scrollPercentage is within expected boundaries
    if (scrollPercentage < 0) {
      scrollPercentage = 0;
    }
  
    // Use the scroll percentage to adjust the translation
    target.style.transform = `translateX(${scrollPercentage * -100}%)`;
  });
  